import styles from './styles.module.scss'
import { getOrderStatus } from '../helpers/getOrderStatus'
import { Order } from '@components/account/types'
import { OrderItemHeader } from './OrderItemHeader'
import { OrderItemContent } from './OrderItemContent'
import { formatDate } from '@helpers/utils'

export default function OrderListItem({ order }: { order: Order }) {
  const {
    name,
    id,
    createdAt,
    cancelledAt,
    fulfillments,
    lineItems,
    shippingAddress,
    refunds
  } = order || {}
  const { status, label } = getOrderStatus(
    fulfillments,
    lineItems,
    cancelledAt,
    refunds
  )

  const orderId = id.split('/').pop() || ''

  return (
    <div className={styles.OrderItem}>
      <OrderItemHeader name={name} status={status} label={label}>
        Order placed: {formatDate(createdAt)}
      </OrderItemHeader>
      <OrderItemContent
        fulfillments={fulfillments}
        lineItems={lineItems}
        createdAt={createdAt}
        name={name}
        id={orderId}
        status={status}
        zipCode={shippingAddress?.zip}
      />
    </div>
  )
}
